"use client"

import CommonCTASection from "@/components/CommonCTASection/CommonCTASection";
import "./UiUxCTASection.scss";

const UiUxCTASection = ({ cta}) => {

     const { title, description, buttonText  } = cta;
  return (
      <CommonCTASection
      title={title}
      description={description}
      buttonText={buttonText}
      sectionClass="get-started-custom-section"
    />
  );
};

export default UiUxCTASection;